import React, { useEffect, useRef, useState } from 'react'
import classes from './ContentBankItem.module.css'
import AuthorIcon from '../../../../assests/ContentBank/Author.png';
import LikeIcon from '../../../../assests/ContentBank/like.png';
import DisIcon from '../../../../assests/ContentBank/dis.png';
import FavoriteIcon from '../../../../assests/ContentBank/favorite.png';
import NotFavoriteIcon from '../../../../assests/ContentBank/not-favorite.png';
import { useSelector } from 'react-redux'
import AuthorLevelPopup from './AuthorLevelPopup'
import ProjectPopup from './ProjectPopup';
import { onKeyDown } from '../../../../service';

const ContentBankItem = ({ contentBankItem, showProjectPopup, setContentBankItem, setMessage, handleEditName, handleDelete, handleCopy, handleForward, handleDownload, handleRestore }) => {

    const popupRef = useRef(null)
    const [successPopup, setSuccessPopup] = useState()
    const [ideIcon, setIdeIcon] = useState()
    const { user } = useSelector(state => state.auth);
    const uiData = useSelector((state) => state.general.uiData);
    const ideId = contentBankItem?.ide?.id || (contentBankItem?.contentData && JSON.parse(contentBankItem.contentData)?.Ide?.Id);

    useEffect(() => {
        if (uiData.ides && ideId)
            setIdeIcon(uiData.ides[ideId - 1]?.icon)
    }, [uiData])

    const getAuthorName = () => {
        return contentBankItem.Author || contentBankItem.user ? contentBankItem.user.firstName + " " + contentBankItem.user.lastName : user.firstName + " " + user.lastName
    }

    return (
        <div className={classes.ItemContainer}>
            <div className={classes.ContentBankItem} ref={popupRef} onClick={() => setContentBankItem && setContentBankItem(contentBankItem)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setContentBankItem && setContentBankItem(contentBankItem))}>
                <div className={classes.HeaderContainer}>
                    <div className={classes.Author}>
                        <img src={AuthorIcon} alt='AuthorIcon' />
                        <div className={classes.AuthorName}>{getAuthorName()}</div>
                    </div>
                    {/* <AuthorLevelPopup contentBankItem={contentBankItem} /> */}
                </div>
                <div className={classes.ContentBankItemContainerWrapper}>
                    {contentBankItem.thumbnail ? <img src={contentBankItem.thumbnail} alt="thumbnail" className={classes.ContentBankItemContainer} /> : ''}
                    {ideIcon && <img className={classes.IdeIcon} src={ideIcon} alt="ideIcon" />}
                    {/* <img className={classes.FavoriteIcon} src={contentBankItem.iFavorite ? FavoriteIcon : NotFavoriteIcon} /> */}
                </div>
                {/* <div className={classes.ContentBankItemMore}>
                    <div className={classes.Like}>
                        <div className={classes.NumLikes}>{contentBankItem.likes && 1}</div>
                        <img src={contentBankItem.iLike ? LikeIcon : DisIcon} />
                    </div>
                </div> */}
                <div className={classes.ContentBankItemName}>{contentBankItem.name}</div>
                <div className={classes.ContentBankItemDesc}>{contentBankItem.description}</div>
                {showProjectPopup && <div className={classes.ProjectPopup}><ProjectPopup ideIcon={ideIcon} material={contentBankItem} close={setSuccessPopup} showPopup={message => setSuccessPopup(message)} setMessage={setMessage} getAuthorName={getAuthorName} handleCopy={handleCopy} handleDelete={handleDelete} handleEditName={handleEditName} handleForward={handleForward} handleDownload={handleDownload} handleRestore={handleRestore} /></div>}
                {successPopup}
            </div>
        </div >
    )
}
export default ContentBankItem